/**
 * CSV export for the supply-finance pages. Columns: [{ key, label, value?(row) }].
 * Values are written raw (numbers unformatted, dates as stored) so Excel can sum / sort them;
 * a UTF-8 BOM keeps Arabic project names readable when the file is opened in Excel.
 */
const escapeCell = (value) => {
  if (value === null || value === undefined) return '';
  const text = String(value);
  // Guard against formula injection when the file is opened in a spreadsheet.
  const safe = /^[=+\-@\t\r]/.test(text) && !/^-?\d+(\.\d+)?$/.test(text) ? `'${text}` : text;
  return /[",\n\r]/.test(safe) ? `"${safe.replace(/"/g, '""')}"` : safe;
};

export function toCsv(rows, columns) {
  const header = columns.map((column) => escapeCell(column.label)).join(',');
  const body = rows.map((row) => columns.map((column) => escapeCell(
    typeof column.value === 'function' ? column.value(row) : row[column.key]
  )).join(','));
  return [header, ...body].join('\r\n');
}

/** Builds the CSV and hands it to the browser as a download. Returns the CSV text. */
export function downloadCsv(filename, rows, columns) {
  const csv = toCsv(rows, columns);
  if (typeof window === 'undefined' || typeof document === 'undefined' || !window.URL?.createObjectURL) return csv;
  const blob = new Blob([`﻿${csv}`], { type: 'text/csv;charset=utf-8' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 0);
  return csv;
}

/** 'procurement-orders-2026-09-30.csv' */
export function datedFilename(prefix, now = new Date()) {
  const pad = (value) => String(value).padStart(2, '0');
  return `${prefix}-${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}.csv`;
}
